/**
 * Format `<innerWidth>x<innerHeight>` — exact parity with GA4's
 * `user_properties.viewport_dimensions`. Do not substitute `outerWidth`,
 * `screen.width`, or apply `devicePixelRatio`.
 */
export function getViewportDimensions(): string {
  if (typeof window === 'undefined') return ''
  const w = window.innerWidth
  const h = window.innerHeight
  if (typeof w !== 'number' || typeof h !== 'number' || Number.isNaN(w) || Number.isNaN(h)) {
    return ''
  }
  return `${w}x${h}`
}
